import PageBanner from "@/components/carousel/PageBanner";
import MetaData from "@/components/seo/MetaData";

function AboutUs() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/about-us`;

  return (
    <>
      <MetaData url={pageUrl} />
      <div>
        <PageBanner bannerText="About Us" />
        <div className="px-[1.5rem] lg:px-[13.125rem] mt-[3rem] md:text-[1.125rem] pb-[5.625rem]">
          <div className="space-y-[1.25rem]">
            <p>
              AmarPet now lets you buy all your favorite pet essentials with
              just a few clicks. Our pets are the cherished members of our
              household who need lots of love and care. That is why AmarPet
              brings you the largest online store with top-quality and curated
              pet care essentials, foods, accessories, and hygiene products that
              are available at your fingertips, anywhere, anytime
            </p>
            <p>
              So browse, and order away your required pet care goodies and
              ensure the well-being of your pets without any hassle. Because,
              your pets deserve the best care too!
            </p>
          </div>

          <div className="mt-[2.75rem]">
            <h2 className="mb-5 font-medium text-xl">🐈What’s in store:</h2>

            <ul className="space-y-4">
              <li>
                🐾&nbsp;A Paw-some Collection: Explore a vast array of pet
                products, from treats, toys to accessories – all in one place!
              </li>
              <li>
                🐾&nbsp;Convenience all the Way: Order at your convenience,
                whether in moments of comfort or urgency and provide your pets
                with the best care
              </li>

              <li>
                🐾&nbsp;Trusted by Pet Parents: Rest assured in getting the best
                and top-tier products for your pets.
              </li>

              <li>
                🐾&nbsp;Tail-Wagging Deals: Stay updated on offers, discounts,
                and deals that will make both of you and your pets hop for joy!
              </li>
            </ul>
          </div>

          <p className="mt-6">
            Start on your hassle-free pet care journey today!
          </p>

          <div>
            <h3 className="text-xl font-medium mb-4 mt-6">
              Legal Information:
            </h3>
            <p>Amarpet Limited Trade Licence: TTRAD/DNCC/010521/2023</p>
            <p>BIN: 005894576-0101</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
